export default "__VITE_ASSET__DRJdfAtj__"